import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './ChatConsoleSidebar.module.scss';
import ChatHeader from './components/chat-header/ChatHeader';
import Chats from './components/chat-body/Chats';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { isEmpty } from 'lodash';
import SidebarFooter from 'component/layout/sidebar-new/components/footer/SidebarFooter';
import { useFetch } from 'hooks/useFetch';
import { scriptEndpoints } from 'hooks/endpoints';
import { useChatSidebar } from 'app-context/Chat-sidebar-context/ChatSidebarContext';

const ChatConsoleSidebar = ({
  getActiveChat,
  chatsData,
  onNewChatClick,
  onSearch,
  refetchChatsList,
  isLoading,
  isUserChat,
}) => {
  const {
    isOpen: sidebarOpen,
    toggle: toggleSidebar,
    close,
  } = useChatSidebar();
  const [currentChat, setCurrentChat] = useState('');

  const effectiveSidebarOpen = isUserChat ? sidebarOpen : true;

  useEffect(() => {
    close();
  }, [close]);

  const setLastChatSelection = (nextList) => {
    const list = Array.isArray(nextList) ? nextList : chatsData;
    if (!Array.isArray(list) || list.length === 0) return;

    const firstId = list.slice().reverse()[0]?.chatId;
    if (!firstId) return;

    setCurrentChat(firstId);
    getActiveChat(firstId);
  };

  const botsQueryKey = useMemo(() => ['botsData'], []);
  const botsEndpoint = useMemo(() => scriptEndpoints.getBots(), []);
  const botsParams = useMemo(() => ({ pageNumber: 1, pageSize: 2000 }), []);
  const botsFetchOptions = useMemo(
    () => ({
      enabled: isUserChat,
      // staleTime: 30 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }),
    [isUserChat],
  );

  const {
    data: BotsData,
    isLoading: botsLoading,
    isFetching: botsFetching,
  } = useFetch(botsQueryKey, botsEndpoint, botsFetchOptions, botsParams);

  const bots = useMemo(() => BotsData?.data || [], [BotsData?.data]);

  const handleChatSelectFromModal = useCallback(
    (chat) => {
      const id = chat?.chatId;
      if (!id) return;
      setCurrentChat(id);
      getActiveChat(id);
    },
    [getActiveChat],
  );

  return (
    <div
      className={`${styles['chat-sidebar']} ${
        sidebarOpen ? styles.open : styles.closed
      }`}
    >
      <ChatHeader
        onMenuClick={toggleSidebar}
        isOpen={sidebarOpen}
        isExpanded={sidebarOpen}
        onSearch={onSearch}
        onNewChatClick={onNewChatClick}
        isUserChat={isUserChat}
        chatsData={chatsData}
        refetchChatsList={refetchChatsList}
        onChatSelect={handleChatSelectFromModal}
        bots={bots}
        botsLoading={botsLoading}
        botsFetching={botsFetching}
      />

      <div
        className={`${styles['chat-body']} ${
          isUserChat && !effectiveSidebarOpen ? styles['chat-body-closed'] : ''
        }`}
      >
        {!sidebarOpen ? null : !isEmpty(chatsData) ? (
          <Chats
            data={chatsData?.slice().reverse()}
            title='today'
            getActiveChat={getActiveChat}
            currentChat={currentChat}
            refetchChatsList={refetchChatsList}
            setLastChatSelection={setLastChatSelection}
          />
        ) : !isLoading ? (
          <div className={styles['no-data']}>
            <SvgWithBranding type='noChat' />
            <p>No Chat Found</p>
          </div>
        ) : null}
      </div>

      {isUserChat && sidebarOpen && BotsData ? (
        <SidebarFooter data={BotsData} isUserChat={isUserChat} />
      ) : null}
    </div>
  );
};

export default ChatConsoleSidebar;
